<template>
  <div :class="[mode]" class="wysiwyg-content-type ck-content">
    <div v-html="content" />
  </div>
</template>
<script>
export default {
  name: 'Wysiwyg',
  props: ['model'],
  computed: {
    content: function() {
      return this.model.content
    },
    mode: function() {
      return `wysiwyg-${this.model.metadata.mode}`
    }
  }
}
</script>
<style lang="scss" >
@import '~vuetify/src/styles/settings/_variables';

.wysiwyg-content-type {
  font-size: 1.6rem;

  &.fit {
    padding: 2.4rem;
    background-color: #ffffff;
  }
}

.wysiwyg-header {
  color: white;
  height: 28rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: inherit;
  padding: 0;
}

// @media #{map-get($display-breakpoints, 'xs-only')} {
//   .wysiwyg-content-type {
//     padding-left: 8px;
//     padding-right: 8px;
//   }
// }
</style>
